<template>
  <Teleport to="body">
    <div
      v-if="hasUpdate"
      class="update-notification"
      :class="{ 'show': hasUpdate }"
    >
      <div class="update-content">
        <div class="update-icon">
          <i class="bi bi-arrow-clockwise"></i>
        </div>
        <div class="update-text">
          <strong>Νέα Ενημέρωση Διαθέσιμη!</strong>
          <p>Μια νέα έκδοση της εφαρμογής είναι διαθέσιμη. Κάντε κλικ για ανανέωση.</p>
        </div>
        <div class="update-actions">
          <button class="btn-update" @click="handleUpdate">
            <i class="bi bi-arrow-repeat me-1"></i>
            Ανανέωση
          </button>
          <button class="btn-dismiss" @click="handleDismiss">
            <i class="bi bi-x"></i>
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import { useAppVersion } from '@/composables/useAppVersion'

const { hasUpdate, checkForUpdates, updateApp, dismissUpdate } = useAppVersion()

// Check for updates on mount
onMounted(() => {
  checkForUpdates()
})

// Check for updates periodically (every 30 minutes)
let updateCheckInterval: number | null = null
onMounted(() => {
  updateCheckInterval = window.setInterval(() => {
    checkForUpdates()
  }, 30 * 60 * 1000) // 30 minutes
})

onUnmounted(() => {
  if (updateCheckInterval) {
    clearInterval(updateCheckInterval)
  }
})

const handleUpdate = () => {
  updateApp()
}

const handleDismiss = () => {
  dismissUpdate()
}
</script>

<style scoped>
.update-notification {
  position: fixed;
  bottom: -200px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999999;
  max-width: 600px;
  width: 90%;
  transition: bottom 0.4s ease;
}

.update-notification.show {
  bottom: 20px;
}

.update-content {
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
  color: white;
  padding: 1.25rem 1.5rem;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  gap: 1rem;
}

.update-icon {
  font-size: 2rem;
  animation: rotate 2s linear infinite;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.update-text {
  flex: 1;
}

.update-text strong {
  display: block;
  margin-bottom: 0.25rem;
  font-size: 1.1rem;
}

.update-text p {
  margin: 0;
  font-size: 0.9rem;
  opacity: 0.9;
}

.update-actions {
  display: flex;
  gap: 0.5rem;
}

.btn-update {
  background: white;
  color: #3b82f6;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
}

.btn-update:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.3);
}

.btn-dismiss {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: none;
  padding: 0.5rem 0.75rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  font-size: 1.2rem;
}

.btn-dismiss:hover {
  background: rgba(255, 255, 255, 0.3);
}

@media (max-width: 576px) {
  .update-content {
    flex-direction: column;
    text-align: center;
  }

  .update-actions {
    width: 100%;
    justify-content: center;
  }
}
</style>
